/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './survey-option-choice.reducer';

export const SurveyOptionChoiceDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const surveyOptionChoiceEntity = useAppSelector(state => state.surveyOptionChoice.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="surveyOptionChoiceDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.surveyOptionChoice.detail.title">SurveyOptionChoice</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.surveyOptionChoice.id">Id</Translate>
            </span>
          </dt>
          <dd>{surveyOptionChoiceEntity.id}</dd>
          <dt>
            <span id="optionChoiceName">
              <Translate contentKey="tinyMedicRestApp.surveyOptionChoice.optionChoiceName">Option Choice Name</Translate>
            </span>
          </dt>
          <dd>{surveyOptionChoiceEntity.optionChoiceName}</dd>
          <dt>
            <span id="sortOrder">
              <Translate contentKey="tinyMedicRestApp.surveyOptionChoice.sortOrder">Sort Order</Translate>
            </span>
          </dt>
          <dd>{surveyOptionChoiceEntity.sortOrder}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.surveyOptionChoice.active">Active</Translate>
            </span>
          </dt>
          <dd>{surveyOptionChoiceEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.surveyOptionChoice.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{surveyOptionChoiceEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.surveyOptionChoice.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{surveyOptionChoiceEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.surveyOptionChoice.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{surveyOptionChoiceEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.surveyOptionChoice.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{surveyOptionChoiceEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.surveyOptionChoice.surveyOptionGroup">Survey Option Group</Translate>
          </dt>
          <dd>{surveyOptionChoiceEntity.surveyOptionGroup ? surveyOptionChoiceEntity.surveyOptionGroup.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/survey-option-choice" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/survey-option-choice/${surveyOptionChoiceEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SurveyOptionChoiceDetail;
